// extracted by mini-css-extract-plugin
module.exports = {"root":"Tabs_root__TVmHU","tab":"Tabs_tab__22nBM","tabActive":"Tabs_tabActive__1oRGC"};